import { DataRoomSheet } from 'router/subrouters/DataRoom/models/DataRoom';

export type AddDataRoomsTable = Pick<
  DataRoomSheet,
  | 'dataRoomName'
  | 'ownerFirstName'
  | 'ownerLastName'
  | 'ownerEmail'
  | 'colleagues'
>;

export type AddDataRoomsTableKeys = keyof AddDataRoomsTable;

export const TABLE_COLUMNS: Array<AddDataRoomsTableKeys> = [
  'dataRoomName',
  'ownerFirstName',
  'ownerLastName',
  'ownerEmail',
  'colleagues',
];

export const HEADER_OPTIONS: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  dataRoomName: 'dataRoomName',
  ownerFirstName: 'ownerFirstName',
  ownerLastName: 'ownerLastName',
  ownerEmail: 'ownerEmail',
  colleagues: 'colleagues',
};

export const REQUIRED_COLUMNS = [
  'dataRoomName',
  'ownerFirstName',
  'ownerLastName',
  'ownerEmail',
];

export const IGNORE_COLUMNS = ['_id'];
